// scan type / gate type 7 = CCTV (FaceMe camera)
export const CCTV_TYPE_ID = 7;

export interface CCTVFilter {
  filterID: string;
  filterName: string;
  filterGateIDList: number[];
  filterCompanyIDList: number[];
  filterPersonTypeIDList: string[];
  filterStartDate: Date | null;
  filterEndDate: Date | null;
}

// query params for /scan-cctv (CCTV only by itself)
export const getCCTVSearchParams = ({
  filterID,
  filterName,
  filterGateIDList,
  filterCompanyIDList,
  filterPersonTypeIDList,
  filterStartDate,
  filterEndDate
}: CCTVFilter) => {
  const searchParams = new URLSearchParams();
  if (filterID) {
    searchParams.set('personal_id', `${filterID}`);
  }
  if (filterName) {
    searchParams.set('name', `${filterName}`);
  }
  filterGateIDList.forEach((gate_id) => {
    searchParams.append('gate_id', `${gate_id}`);
  });
  filterCompanyIDList.forEach((company_id) => {
    searchParams.append('company_id', `${company_id}`);
  });
  filterPersonTypeIDList.forEach((person_type_id) => {
    searchParams.append('person_type_id', `${person_type_id}`);
  });
  if (filterStartDate) {
    searchParams.set('start_date', `${filterStartDate.toISOString()}`);
  }
  if (filterEndDate) {
    searchParams.set('end_date', `${filterEndDate.toISOString()}`);
  }
  return searchParams;
};
